import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getWithdrawalEligibility = {
  name: "getWithdrawalEligibility" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    /**
     * Shopify line item ids that are ineligible for withdrawal because they
     * match a configured withdrawal exclusion (collection, tag, or variant
     * metafield). Display-only preview; the authoritative check runs on submit.
     */
    ineligibleLineItemIds: z.array(z.string()),
  }),
};
